import { FALLBACK_DEFAULT_CURRENCY } from "./constants";

export const selectDefaultCurrency = (state) =>
  state.currency?.defaultCurrency ?? FALLBACK_DEFAULT_CURRENCY;

export const selectDefaultCurrencyCode = (state) =>
  selectDefaultCurrency(state).code;

export const selectCurrencyRates = (state) => state.currency?.rates ?? [];

export const selectSupportedCurrencies = (state) =>
  state.currency?.supportedCurrencies ?? [];

export const selectCurrencyRateMap = (state) =>
  (state.currency?.rates ?? []).reduce(
    (map, rate) => ({ ...map, [rate.code]: rate.rate }),
    {}
  );

export const selectCurrencyIsLoading = (state) =>
  Boolean(state.currency?.isLoading);

export const selectCurrencyLoaded = (state) => Boolean(state.currency?.loaded);

export const selectCurrencyError = (state) => state.currency?.error ?? null;
